"use client";

import { NotificationItem } from "./NotificationItem";
import type { CampaignType } from "./NotificationItem";
import { Bell } from "lucide-react";

interface NotificationListProps {
  campaigns: CampaignType[];
  onDismiss: (campaignId: string) => void;
  onClick: (campaign: CampaignType) => void;
}

export const NotificationList = ({ campaigns, onDismiss, onClick }: NotificationListProps) => {
  if (campaigns.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <Bell className="mb-2 h-8 w-8 text-cede-text-disabled" />
        <p className="body2 text-cede-text-secondary">No new notifications</p>
        <p className="caption text-cede-text-disabled">You&apos;re all caught up!</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {campaigns.map((campaign) => (
        <NotificationItem key={String(campaign.id)} campaign={campaign} onDismiss={onDismiss} onClick={onClick} />
      ))}
    </div>
  );
};
